import { sumBy } from 'es-toolkit';
import { convertDateESTToUTCToUserLocal, convertDateStringtoMoment, truncateTimeZoneDate } from './dates';
import { convertToFloat, trimObjectValues, valueToNumber, valueToString } from './format';

export const convertPreClaimsFilesToAPI = (files) => {
  const newFiles = [];
  files.forEach((fileDetails) => {
    if (fileDetails.fileList) {
      fileDetails.fileList.forEach((file) => {
        newFiles.push({
          claimKey: 0,
          sequence: file.sequence,
          fileComments: valueToString(fileDetails.fileComments),
          fileName: valueToString(file.fileName),
          documentType: valueToNumber(fileDetails.documentType),
          //   description: "string",
          fileContent: valueToString(file.fileContent),
          dirtyFlag: file.dirtyFlag,
          originalFileName: '',
        });
      });
    }
  });
  return newFiles;
};

export const LADCovertDatesToMomentType = (data) => {
  return {
    ...data,
    invoiceDate: convertDateESTToUTCToUserLocal(convertDateStringtoMoment(data?.invoiceDate)),
    dateFiled: convertDateStringtoMoment(data?.dateFiled),
    dateShipped: convertDateESTToUTCToUserLocal(convertDateStringtoMoment(data?.dateShipped)),
    claimCloseDate: convertDateStringtoMoment(data?.claimCloseDate),
    dateAck: convertDateStringtoMoment(data?.dateAck),
    apDate: convertDateESTToUTCToUserLocal(convertDateStringtoMoment(data?.apDate)),
    checkDateToCustomer: convertDateStringtoMoment(data?.checkDateToCustomer),
    disableItems: Boolean(data.disableItems === 'Y'),
    disableInterest: Boolean(data.disableInterest === 'Y'),
    disableProration: Boolean(data.disableProration === 'Y'),
    disableLabor: Boolean(data.disableLabor === 'Y'),
    disableInspection: Boolean(data.disableInspection === 'Y'),
    disableDocumentation: Boolean(data.disableDocumentation === 'Y'),
    claimMinCharge: Boolean(data.claimMinCharge === 'Y'),
  };
};

export const LADCovertDatesFromMomentToAPIType = (data) => {
  return {
    ...data,
    invoiceDate: truncateTimeZoneDate(data?.invoiceDate),
    dateFiled: truncateTimeZoneDate(data?.dateFiled),
    dateShipped: truncateTimeZoneDate(data?.dateShipped),
    claimCloseDate: truncateTimeZoneDate(data?.claimCloseDate),
    dateAck: truncateTimeZoneDate(data?.dateAck),
    apDate: truncateTimeZoneDate(data?.apDate),
    checkDateToCustomer: truncateTimeZoneDate(data?.checkDateToCustomer),
    disableItems: data.disableItems ? 'Y' : 'N',
    disableInterest: data.disableInterest ? 'Y' : 'N',
    disableProration: data.disableProration ? 'Y' : 'N',
    disableLabor: data.disableLabor ? 'Y' : 'N',
    disableInspection: data.disableInspection ? 'Y' : 'N',
    disableDocumentation: data.disableDocumentation ? 'Y' : 'N',
    claimMinCharge: data.claimMinCharge ? 'Y' : 'N',
  };
};

export const LDClaimsItemCalculation = (paramItem, paramCustomerSettings) => {
  const item = trimObjectValues(paramItem);
  const customerSettings = trimObjectValues(paramCustomerSettings);
  let totalWeight = 0;
  let itemQuantity = valueToNumber(item.itemQuantity);
  let itemUnitWeight = valueToNumber(item.itemUnitWeight);
  let value = valueToNumber(item.value);
  let totalValue = valueToNumber(item.totalValue);
  let smAmount = valueToNumber(item.smAmount);
  let productClaimAmount = valueToNumber(item.productClaimAmount);

  // Check for NULL's
  if (Number.isNaN(itemQuantity)) itemQuantity = 0;
  if (Number.isNaN(itemUnitWeight)) itemUnitWeight = 0;
  if (Number.isNaN(totalWeight)) totalWeight = 0;
  if (Number.isNaN(value)) value = 0;
  if (Number.isNaN(totalValue)) totalValue = 0;
  if (Number.isNaN(smAmount)) smAmount = 0;
  if (Number.isNaN(value)) value = 0;
  if (Number.isNaN(productClaimAmount)) productClaimAmount = 0;

  totalWeight = (itemQuantity * itemUnitWeight).toFixed(2);
  if (item.fullRelFlag === 'F') totalValue = (itemQuantity * value).toFixed(2);
  else if (item.fullRelFlag === 'R') totalValue = (totalWeight * value).toFixed(2);
  if (customerSettings.bypassClaimItemWeight !== 'Y') item.totalWeight = totalWeight;
  if (customerSettings.bypassClaimItemTotal !== 'Y') item.totalValue = totalValue;

  if (item.smFlag === 'SC') {
    if (item.smType === 'P') {
      productClaimAmount = totalValue - (totalValue * smAmount) / 100;
    } else {
      productClaimAmount = totalValue - smAmount;
    }
  } else if (item.smFlag === 'MD' || item.smFlag === 'RC') {
    if (item.smType === 'P') {
      productClaimAmount = (totalValue * smAmount) / 100;
    } else {
      productClaimAmount = smAmount;
    }
  } else {
    productClaimAmount = totalValue;
  }

  if (productClaimAmount == null || productClaimAmount === '') productClaimAmount = 0;
  item.productClaimAmount = Number.parseFloat(productClaimAmount).toFixed(2);
  return item;
};

export const LDClaimInspectionCostCalculation = (financialData, customerSettings) => {
  let ls_rate;
  let ls_cost;
  let ls_hours;

  ls_cost = Number.parseFloat(valueToNumber(financialData.inspectionCost));

  if (Number.isNaN(ls_cost)) ls_cost = 0;
  if (Number.isNaN(ls_hours)) ls_hours = 0;

  if (financialData.disableInspection) {
    return ls_cost;
  }
  ls_rate = Number.parseFloat(customerSettings?.inspectorRate);
  if (Number.isNaN(ls_rate)) {
    ls_rate = 0;
  }

  ls_hours = Number.parseFloat(valueToNumber(financialData.inspectionHours));
  if (Number.isNaN(ls_hours)) {
    ls_hours = 0;
  }
  const inspectionCost = Number.parseFloat(ls_rate * ls_hours).toFixed(2);
  return inspectionCost;
};

export const LDClaimInterestCalculation = (financialData, customerSettings, detailsData, paramAl_total) => {
  //al_total -> Total Claim
  let ll_days = 0;
  let ll_mod = 0;
  let ls_ship_date = '';
  let ls_file_date = '';
  let ll_claim_interest_rate;
  const ll_compound = 30;
  let ll_months;
  let ll_newtotal;
  let ll_interest = valueToNumber(financialData.interestExpense);
  // let ld_ship_date;
  // let ld_file_date;
  // const ll_lastindex = 0;
  // const ll_year = 0;
  // let ls_year;
  const al_total = valueToNumber(paramAl_total);

  if (financialData.disableInterest) {
    return { claimTotal: al_total, interestExpense: ll_interest };
  }

  ls_ship_date = detailsData?.dateShipped;
  if (ls_ship_date === '') {
    return { claimTotal: al_total, interestExpense: ll_interest };
  }

  if (!ls_ship_date?.isValid()) {
    return { claimTotal: al_total, interestExpense: ll_interest };
  }

  // ls_ship_date = toFourCharYear(ls_ship_date);
  //ld_ship_date = Date.parse(ls_ship_date);

  // ls_ship_date = new Date(ls_ship_date);

  // ls_file_date = $("#Filed").val();
  ls_file_date = detailsData?.dateFiled;
  if (ls_file_date === '') {
    return { claimTotal: al_total, interestExpense: ll_interest };
  }
  if (!ls_file_date?.isValid()) {
    return { claimTotal: al_total, interestExpense: ll_interest };
  }
  //ls_file_date = toFourCharYear(ls_file_date);
  //ld_file_date = Date.parse(ls_file_date);

  // ls_file_date = new Date(ls_file_date);

  ll_claim_interest_rate = valueToNumber(customerSettings.claimInterestRate);
  if (ll_claim_interest_rate === '') {
    ll_claim_interest_rate = 0;
  }

  if (Number.isNaN(ll_claim_interest_rate) || ll_claim_interest_rate <= 0) {
    return { claimTotal: al_total, interestExpense: ll_interest };
  }

  ll_claim_interest_rate = ll_claim_interest_rate * 100;

  // ll_days = dateDiff(ls_ship_date, ls_file_date, "d") + 30;
  ll_days = ls_file_date.diff(ls_ship_date, 'days') + 30;
  ll_mod = ll_days % ll_compound;
  ll_months = ll_days / ll_compound;
  if (ll_mod >= 15) {
    ll_months++;
  }
  ll_months = Number.parseInt(ll_months);

  ll_newtotal = al_total * (1 + (ll_months * ll_claim_interest_rate) / 100);

  /// ll_newtotal = al_total * (1 + (ll_months * ll_claim_interest_rate) / 100);
  ll_interest = ll_newtotal - al_total;
  ll_interest = ll_interest.toFixed(2);

  //convert interest value before assigning to field if necessary
  // $("#InterestExpense").val(ll_interest);

  ll_newtotal = ll_newtotal.toFixed(2);
  return { claimTotal: ll_newtotal, interestExpense: ll_interest };
};

export const LDClaimLabourCostCalculation = (financialData, customerSettings) => {
  let ls_rate;
  let ls_cost = valueToNumber(financialData.laborCharge);
  let ls_hours;

  if (Number.isNaN(ls_cost)) ls_cost = 0;
  if (Number.isNaN(ls_hours)) ls_hours = 0;

  if (financialData.disableLabor) {
    return ls_cost;
  }
  ls_rate = valueToNumber(customerSettings?.laborRate);
  if (Number.isNaN(ls_rate)) {
    ls_rate = 0;
  }

  ls_hours = valueToNumber(financialData.laborHours);
  if (Number.isNaN(ls_hours)) {
    ls_hours = 0;
  }
  return Number.parseFloat(ls_rate * ls_hours).toFixed(2);
};

export const LDClaimProRatedCalculation = (financialData, items) => {
  const ll_weight = valueToNumber(financialData.cargoShipmentWeight);
  const ll_chg = valueToNumber(financialData.claimFreightCharge);
  let ll_sumwgt = 0;
  let ll_frt = 0;

  if (financialData.disableProration) {
    return 0;
  }

  if (Number.isNaN(ll_weight) || ll_weight <= 0) {
    // $("#Weight").val(0);
    return 0;
  }

  if (Number.isNaN(ll_chg) || ll_chg <= 0) {
    // $("#ProRated").val(0);
    return 0;
  }

  ll_frt = ll_chg / ll_weight;

  ll_sumwgt = sumBy(items, ({ totalWeight }) => valueToNumber(totalWeight));

  return (ll_frt * ll_sumwgt).toFixed(2);
};

export const LDClaimFinancialCalculation = (financialData, customerSettings, items, detailsData) => {
  //Items variables
  let ll_sum_total_of_all = 0;
  let ll_sum_total_wgt = 0;
  let ll_total_salvage_amount = 0;
  let ll_total_markdown_amount = 0;
  let ll_total_repair_amount = 0;
  let ll_total_product_claim_amount = 0;
  let ls_s_m_flag;
  let ls_s_m_type;
  let ll_total_value;
  let ll_item_unit_weight;
  let ll_item_quantity;
  let ll_s_m_amount;

  //Claim variables
  let ll_deduct_amt;
  let ll_frt_chg;
  let ll_prorate_amt;
  let ll_credit_amt;
  let ll_add_chg;
  let ll_admin_chg;
  let ll_tax_amt;
  let ll_labor_chg;
  let ll_inspect_cost;
  let ll_total_shipment_wgt;
  let ll_claimed_freight = 0;
  let ll_total_claim_amount = 0;
  let ll_total_claim_amt = 0;

  //Cust. Pref info
  let ls_bypass_claim_total;
  // let ls_bypass_claim_admin;

  let ll_thisitemtotal = 0;
  let ll_sal_ded_amt = 0;

  if (Number(customerSettings?.customerKey) === 0) {
    if (!financialData.disableDocumentation) {
      financialData.claimAdminCharge = valueToNumber(customerSettings?.adminFees);
    }
  }

  if (!financialData.disableProration) {
    financialData.freightChargeClaimed = LDClaimProRatedCalculation(financialData, items);
  }
  //else
  //{
  // $('#ProRated').val(ll_prorate_amt.toFixed(2));
  //}

  if (!financialData.disableLabor) {
    financialData.laborCharge = LDClaimLabourCostCalculation(financialData, customerSettings);
  }

  if (!financialData.disableInspection) {
    financialData.inspectionCost = LDClaimInspectionCostCalculation(financialData, customerSettings);
  }

  //Get bypass info
  ls_bypass_claim_total = 'N';
  ls_bypass_claim_total = ls_bypass_claim_total.toUpperCase();
  //ls_bypass_claim_admin = ls_bypass_claim_admin.toUpperCase();

  // //Load up the Financials screen variables

  ll_deduct_amt = valueToNumber(financialData.claimDeductibleAmount);
  ll_frt_chg = valueToNumber(financialData.claimFreightCharge);
  ll_prorate_amt = valueToNumber(financialData.freightChargeClaimed);
  ll_credit_amt = valueToNumber(financialData.claimCreditAmount);
  ll_add_chg = valueToNumber(financialData.claimAddCharge);
  ll_admin_chg = valueToNumber(financialData.claimAdminCharge);
  ll_tax_amt = valueToNumber(financialData.claimTaxAmount);
  ll_labor_chg = valueToNumber(financialData.laborCharge);
  ll_inspect_cost = valueToNumber(financialData.inspectionCost);
  ll_total_shipment_wgt = valueToNumber(financialData.cargoShipmentWeight);

  //Check for nulls - if so, set to zero
  if (Number.isNaN(ll_deduct_amt) || ll_deduct_amt === '') ll_deduct_amt = 0;
  if (Number.isNaN(ll_frt_chg) || ll_frt_chg === '') ll_frt_chg = 0;
  if (Number.isNaN(ll_prorate_amt) || ll_prorate_amt === '') ll_prorate_amt = 0; //changed on 10/31/2005
  if (Number.isNaN(ll_credit_amt) || ll_credit_amt === '') ll_credit_amt = 0;
  if (Number.isNaN(ll_add_chg) || ll_add_chg === '') ll_add_chg = 0;
  if (Number.isNaN(ll_admin_chg) || ll_admin_chg === '') ll_admin_chg = 0;
  if (Number.isNaN(ll_tax_amt) || ll_tax_amt === '') ll_tax_amt = 0;
  if (Number.isNaN(ll_labor_chg) || ll_labor_chg === '') ll_labor_chg = 0;
  if (Number.isNaN(ll_inspect_cost) || ll_inspect_cost === '') ll_inspect_cost = 0;
  if (Number.isNaN(ll_total_shipment_wgt) || ll_total_shipment_wgt === '') ll_total_shipment_wgt = 0;

  //Use XPATH to walk thru the Items and calculate new totals
  // lobjClm = gobjClaim.gobjDataIsland.XMLDocument.childNodes(0).childNodes(0);
  // lobjThis = gobjItems.gobjDataIsland.XMLDocument.childNodes(0);

  items.forEach((paramElement) => {
    const element = trimObjectValues(paramElement);
    ls_s_m_flag = element.smFlag;
    ls_s_m_flag = ls_s_m_flag != null ? ls_s_m_flag.toUpperCase() : ls_s_m_flag;

    ls_s_m_type = element.smType;
    ls_s_m_type = ls_s_m_type != null ? ls_s_m_type.toUpperCase() : ls_s_m_type;

    ll_total_value = Number.parseFloat(element.totalValue);

    ll_item_unit_weight = Number.parseFloat(element.itemUnitWeight);

    ll_item_quantity = Number.parseFloat(element.itemQuantity);

    ll_s_m_amount = Number.parseFloat(element.smAmount);

    ll_thisitemtotal = Number.parseFloat(element.productClaimAmount);

    //Now, do the math
    //first time ll_sum_total_of_all appears ie initializing ll_sum_total_of_all
    ll_sum_total_of_all = ll_sum_total_of_all + ll_total_value;
    //ll_sum_total_wgt initialization
    ll_sum_total_wgt = ll_sum_total_wgt + ll_item_unit_weight * ll_item_quantity;

    if (ls_s_m_flag === 'MD') {
      ll_total_markdown_amount = ll_total_markdown_amount + ll_s_m_amount;
    }

    if (ls_s_m_flag === 'RC') {
      //ll_total_repair_amount initialized
      ll_total_repair_amount = ll_total_repair_amount + ll_s_m_amount;
    }

    if (ls_s_m_flag === 'SC') {
      if (ls_s_m_type === 'P')
        //initialization of ll_total_salvage_amount
        ll_total_salvage_amount = ll_total_salvage_amount + ll_total_value * (ll_s_m_amount / 100);
      else ll_total_salvage_amount = ll_total_salvage_amount + (ll_total_value - ll_thisitemtotal);

      //initialization of ll_sal_ded_amt
      //ll_total_value = value of Total Value field on Items screen
      //ll_thisitemtotal = value of Product Claim Amount field on Items screen
      //CONVERT value before assigning to field
      ll_sal_ded_amt += ll_total_value - ll_thisitemtotal;
    }
    //ll_total_product_claim_amount initialization
    ll_total_product_claim_amount = ll_total_product_claim_amount + ll_thisitemtotal;
  });

  //START - added by acogent -----------------------------------------------
  //get the Markdown, salvage, repair and product amount if manual items is checked
  if (financialData.disableItems) {
    let salvage = valueToNumber(financialData.salvageAmount);
    if (salvage === '' || salvage == null || Number.isNaN(salvage)) salvage = 0;
    ll_total_salvage_amount = Number.parseFloat(salvage);

    let markdown = valueToNumber(financialData.markdownAmount);
    if (markdown === '' || markdown == null || Number.isNaN(markdown)) markdown = 0;
    ll_total_markdown_amount = Number.parseFloat(markdown);

    let repair = valueToNumber(financialData.repairCostAmount);
    if (repair === '' || repair == null || Number.isNaN(repair)) repair = 0;

    ll_total_repair_amount = Number.parseFloat(repair);

    let product = valueToNumber(financialData.productClaimAmount);
    if (product === '' || product == null || Number.isNaN(product)) product = 0;
    ll_total_product_claim_amount = Number.parseFloat(product);

    ////add the Markdown, salvage and repair if manual items is checked
    ll_total_claim_amt = ll_total_claim_amt + ll_total_salvage_amount; //salvage amount field
    ll_total_claim_amt = ll_total_claim_amt + ll_total_markdown_amount; //markdown amount field
    ll_total_claim_amt = ll_total_claim_amt + ll_total_repair_amount; //repair amount field
  }

  financialData.salvageAmount = Number.parseFloat(ll_total_salvage_amount).toFixed(2);

  financialData.markdownAmount = ll_total_markdown_amount;

  financialData.repairCostAmount = ll_total_repair_amount;

  //END - added by acogent-------------------------------------------------

  //Now, use the items totals to update the Claim info.
  //ll_claimed_freight initialization
  //changed on 10/31/2005. Added a check to calculate pro-rated using ll_prorate_amt
  // when manual prorated is checked otherwise use ll_frt_chg
  // if (gl_calc_proration) {
  if (!financialData.disableProration) {
    if (ll_total_shipment_wgt === 0) ll_claimed_freight = ll_frt_chg;
    //ll_sum_total_wgt = item weight * item quantity for each item
    else ll_claimed_freight = (ll_sum_total_wgt / ll_total_shipment_wgt) * ll_frt_chg;
  } else {
    //for manual proration
    ll_claimed_freight = ll_prorate_amt;
  }

  //Initialization of ll_total_claim_amt
  //ll_total_product_claim_amount = sum of Product Claim Amount of all items
  ll_total_claim_amt = ll_total_product_claim_amount - ll_deduct_amt; //Deductible field
  ll_total_claim_amt = ll_total_claim_amt - ll_credit_amt; // Credit field
  ll_total_claim_amt = ll_total_claim_amt + ll_claimed_freight;
  ll_total_claim_amt = ll_total_claim_amt + ll_add_chg; //Additional Cost field
  ll_total_claim_amt = ll_total_claim_amt + ll_admin_chg; //Documentation Cost field
  ll_total_claim_amt = ll_total_claim_amt + ll_tax_amt; // Tax
  ll_total_claim_amt = ll_total_claim_amt + ll_labor_chg; //Labor Cost
  ll_total_claim_amt = ll_total_claim_amt + ll_inspect_cost; //Inspection Cost

  //Check for Nulls...
  if (Number.isNaN(ll_total_claim_amt)) ll_total_claim_amt = 0;
  if (Number.isNaN(ll_sum_total_of_all)) ll_sum_total_of_all = 0;
  if (Number.isNaN(ll_claimed_freight)) ll_claimed_freight = 0;
  if (Number.isNaN(ll_total_salvage_amount)) ll_total_salvage_amount = 0;
  if (Number.isNaN(ll_total_markdown_amount)) ll_total_markdown_amount = 0;
  if (Number.isNaN(ll_total_repair_amount)) ll_total_repair_amount = 0;
  if (Number.isNaN(ll_sum_total_wgt)) ll_sum_total_wgt = 0;
  if (Number.isNaN(ll_sal_ded_amt)) ll_sal_ded_amt = 0;

  //Round all to 2 places
  ll_total_claim_amt = ll_total_claim_amt.toFixed(2);
  ll_sum_total_of_all = ll_sum_total_of_all.toFixed(2);
  ll_claimed_freight = ll_claimed_freight.toFixed(2);
  ll_total_salvage_amount = ll_total_salvage_amount.toFixed(2);
  ll_total_markdown_amount = ll_total_markdown_amount.toFixed(2);
  ll_total_repair_amount = ll_total_repair_amount.toFixed(2);
  ll_sum_total_wgt = ll_sum_total_wgt.toFixed(2);
  ll_sal_ded_amt = ll_sal_ded_amt.toFixed(2);

  ////Set values for each item
  if (!financialData.disableProration) {
    //$('#Weight').val(ll_sum_total_wgt);
    //$('#FreightCost').val(ll_claimed_freight);
    //$('#Deductible').val(ll_sal_ded_amt);
    //$('#MarkdownAmount').val(ll_total_markdown_amount);
    //$('#RepairCost').val(ll_total_repair_amount);
    financialData.productClaimAmount = ll_total_product_claim_amount;
  }

  ////Set value of Interest Expense field on Financials screen
  if (customerSettings.bypassClaimItemTotal !== 'Y') {
    if (!financialData.disableInterest) {
      const { claimTotal, interestExpense } = LDClaimInterestCalculation(
        financialData,
        customerSettings,
        detailsData,
        ll_total_claim_amt,
      );
      financialData.interestExpense = interestExpense;
      ll_total_claim_amount = claimTotal;
    } else {
      let interestValue = valueToNumber(financialData.interestExpense);
      if (interestValue === '' || interestValue == null || Number.isNaN(interestValue)) interestValue = 0;
      ll_total_claim_amount = Number.parseFloat(ll_total_claim_amt) + Number.parseFloat(interestValue);
    }

    ll_total_claim_amount = Number.parseFloat(ll_total_claim_amount).toFixed(2);
    financialData.claimTotal = ll_total_claim_amount;
  }

  // calculating documentation cost
  if (customerSettings.customerKey && Number(customerSettings.customerKey) !== 0) {
    if (!financialData.disableDocumentation) {
      const cost_from = valueToNumber(customerSettings.processingCostFrom);
      const cost_to = valueToNumber(customerSettings.processingCostTo);
      const documentation_cost =
        Number.parseFloat(ll_total_claim_amount) > Number.parseFloat(cost_from)
          ? Number.parseFloat(ll_total_claim_amount) < Number.parseFloat(cost_to)
            ? Number.parseFloat(valueToNumber(customerSettings.adminFees))
            : 0
          : 0;

      financialData.claimAdminCharge = Number.parseFloat(documentation_cost).toFixed(2); //set Documentation Cost on Financial Screen
    }
  }
  financialData.claimFreightCharge = convertToFloat(financialData.claimFreightCharge);
  financialData.interestExpense = convertToFloat(financialData.interestExpense);
  financialData.claimTaxAmount = convertToFloat(financialData.claimTaxAmount);
  financialData.claimAddCharge = convertToFloat(financialData.claimAddCharge);
  financialData.claimDeductibleAmount = convertToFloat(financialData.claimDeductibleAmount);
  financialData.claimCreditAmount = convertToFloat(financialData.claimCreditAmount);
  return financialData;
};
